import ApiCatalogoConf from "@/services/conf/api/ApiCatalogo.conf";
import catalogoUrl from "@/utils/apiUrl/catalogo.url";
import httpstatus from "@/utils/httpstatus";
import interceptor from "../conf/httpinterceptor";

export default {
    async obtener(){
        try {

            /*Se obtiene la configuracion de la instancia de axios */
            let apiCatalogo = ApiCatalogoConf.getConfiguration()
            
            /*Se configura el interceptor si es necesario, el cual implementa el refreshtoken */
            apiCatalogo.instance = interceptor.getInterceptor(apiCatalogo.instance)

            /*Se configura el url del servicio*/
            apiCatalogo.url = catalogoUrl.APP_CATALOGOS
            
            
            let response = await apiCatalogo.get()

            /*
                {
                "success": true,
                "status": 200,
                "statusText": "OK",
                "data": {
                    "ejecucionCorrecta": true,
                    "httpStatus": 200,
                    "data": [
                    {
                        "id": 1,
                        "descripcion": "ActividadInstitucional",
                        "nombre": "Actividad Institucional",
                        "nombreCampos": "Clave;Descripción",
                        "longitudCampos": "3;1000",
                        "camposClave": 1,
                        "formatoClave": "A99",
                        "pertenece": "P",
                        "numColumnas": 2,
                        "grupo": 1,
                        "subgrupo": 0,
                        "tablaCombo": "",
                        "visualiza": true,
                        "tablasRelacion": "",
                        "nombreRPT": "ActividadInstitucionalRPT"
                    }
                    ],
                    "errores": []
                },
                "headers": {
                    "content-type": "application/json; charset=utf-8"
                }
                }
            */
            /*Muestra el error de la api */
            if(response.data && (!response.data.ejecucionCorrecta || response.data.httpStatus != httpstatus.SUCCESS)){
                throw new Error(response.data.errores ? response.data.errores : httpErrorMessage.DEFAULT_ERROR)
            /*Muetra el error de la libreria hcRequest */
            }else if(response.status != 200){
                throw new Error(response.statusText ? response.statusText : httpErrorMessage.CONECTION_ERROR)
            }
            return response.data 

        } catch (error) {
           throw new Error(error.message)
        }
    },

    // obtener catalogos endpoint
    async getCatalogos(url,data = null){
        try{
            let apiCatalogo = ApiCatalogoConf.getConfiguration()
            apiCatalogo.instance = interceptor.getInterceptor(apiCatalogo.instance);

            if(data){
                Object.entries(data).forEach(([key,value])=> {
                    Object.assign(apiCatalogo.headers, {[key]:value});
                })
            }
            
            /*Se configura el url del servicio*/
            apiCatalogo.url = url;
            let response = await apiCatalogo.get();
             
             if(response.data && (!response.data.ejecucionCorrecta || response.data.httpStatus != httpstatus.SUCCESS)){
                throw new Error(response.data.errores ? response.data.errores : httpErrorMessage.DEFAULT_ERROR)
            
            }else if(response.status != 200){
                throw new Error(response.statusText ? response.statusText : httpErrorMessage.CONECTION_ERROR)
            }
            return response.data 
        } catch (error) {
            throw new Error(error.message)
         }

    },



}